// export const BASE_URL = 'http://10.120.1.11:9082';
export const BASE_URL = 'https://admin.crypto.mobilelab.vn';
// export const BASE_URL = 'http://localhost:9088';
// export const BASE_URL = 'http://127.0.0.1:9088';
// export const BASE_URL = 'http://192.168.100.11:9082';
// export const BASE_URL = 'http://localhost:9082';
// export const BASE_URL = 'http://113.190.221.206:9082';
// export const PREFIX_FRONT_URL = "";
export const PREFIX_FRONT_URL = '';
export const API_VERSION = 'v1';
export const TIME_OF_DEBOUNCE = 300;

const AUTH = {
  ADMINNOTIFICATION: '/adminnotification/',
  ADMINNOTIFICATION_PAGINATE: '/adminnotification/paginate',

  AFFILIATE_ADMIN: '/affiliate-admin/',
  AFFILIATE_ADMIN_HISTORY: '/affiliate-admin/history',

  AUTHORIZATION__CONTROLS: '/authorization/controls/',
  AUTHORIZATION__PERMISSIONS: '/authorization/permissions/',
  AUTHORIZATION__PERMISSIONS__pERMISSIONID: '/authorization/permissions/:permissionId',
  AUTHORIZATION__PERMISSIONS__ROLE__rOLEID: '/authorization/permissions/role/:roleId',
  AUTHORIZATION__ROLE_PERMISSIONS: '/authorization/role-permissions/',
  AUTHORIZATION__ROLE_PERMISSIONS_MULTI: '/authorization/role-permissions/multi',
  AUTHORIZATION__ROLE_PERMISSIONS_ROLE__rOLEID: '/authorization/role-permissions/role/:roleId',
  AUTHORIZATION__ROLE_PERMS_CONTROLS: '/authorization/role-perms-controls/',
  AUTHORIZATION__ROLE_USERS: '/authorization/role-users/',
  AUTHORIZATION__ROLE_USERS__pUBKEY: '/authorization/role-users/:pubkey',
  AUTHORIZATION__ROLE_USERS_MULTI: '/authorization/role-users/multi',
  AUTHORIZATION__ROLES: '/authorization/roles/',
  AUTHORIZATION__ROLES__rOLEID: '/authorization/roles/:roleId',
  AUTHORIZATION__ROLES__USER__pUBKEY: '/authorization/roles/user/:pubkey',

  CAMPAIGN: '/campaign/',
  CAMPAIGN__bID: '/campaign/:bid',
  CAMPAIGN__CONFIG: '/campaign/config',
  CAMPAIGN__CONFIG__BY_ID: '/campaign/config/by-id',
  CAMPAIGN__CONFIG__BY_NAME: '/campaign/config/by-name',
  CAMPAIGN__PAGINATE: '/campaign/paginate',

  COMMISSION: '/commission/',
  COMMISSION__FILTER_TIME: '/commission/filter-time',
  COMMISSION__LIST_COMMISSION_MAP_LEVEL: '/commission/list-commission-map-level',
  COMMISSION__LIST_PARTNER: '/commission/list-partner',
  COMMISSION__TOTAL_REFERRALS: '/commission/total-referrals',
  COMMISSION__USER: '/commission/user/',
  COMMISSION__USER_FILTER_TIME: '/commission/user/filter-time',
  COMMISSION__USER_PAGINATE: '/commission/user/paginate',

  EXCHANGE__OPEN: '/exchange/open',
  EXCHANGE__STATUS_CURRENT: '/exchange/status-current',
  EXCHANGE__STOP: '/exchange/stop',

  FAVORITE__AFFILIATE: '/favorite/affiliate',
  FAVORITE__AFFILIATE__pUBKEY: '/favorite/affiliate/:pubkey',
  FAVORITE__AFFILIATE__DETAIL: '/favorite/affiliate/detail',

  LUCKY_GAME__CONFIG: '/lucky-game/config',
  LUCKY_GAME__TURN: '/lucky-game/turn',

  MANAGER: '/manager/',
  MANAGER__ADD_WALLET: '/manager/add-wallet',
  MANAGER__ADMIN_INFO__pUBKEY: '/manager/admin-info/:pubkey',
  MANAGER__ADMIN_LOGIN: '/manager/admin-login',
  MANAGER__ADMIN_TRANSFER__UID__ADDRESS: '/manager/admin-transfer/:uid/:address',
  MANAGER__ADMIN_WALLETS: '/manager/admin-wallets',
  MANAGER__ADMINS: '/manager/admins',
  MANAGER__ALL_ADMINS: '/manager/all-admins',
  MANAGER__AUTHOR_INFO: '/manager/author-info',
  MANAGER__BALANCES: '/manager/balances',
  MANAGER__BALANCES_TOMO: '/manager/balances-tomo',
  MANAGER__BLOCK__pUBKEY: '/manager/block/:pubkey',
  MANAGER__CREATE: '/manager/create',
  MANAGER__ERR_ERC20: '/manager/err-erc20',
  MANAGER__ERR_TOMO_ERC20: '/manager/err-tomo-erc20',
  MANAGER__FIX_ERR_ERC20: '/manager/fix-err-erc20',
  MANAGER__FIX_ERR_TOMO_ERC20: '/manager/fix-err-tomo-erc20',
  MANAGER__LOGIN_HISTORIES: '/manager/login-histories',
  MANAGER__LOGOUT: '/manager/logout',
  MANAGER__MIGRATE_BTC__aDDRESS: '/manager/migrate-btc/:address',
  MANAGER__MIGRATE_ERC20: '/manager/migrate-erc20',
  MANAGER__MIGRATE_ETH: '/manager/migrate-eth',
  MANAGER__MIGRATE_TOMO: '/manager/migrate-tomo',
  MANAGER__MIGRATE_TOMO_ERC20: '/manager/migrate-tomo-erc20',
  MANAGER__OWN_BALANCES: '/manager/own-balances',
  MANAGER__QR_CONFIRM: '/manager/qr-confirm',
  MANAGER__QR_VERIFY: '/manager/qr-verify',
  MANAGER__UNLOCK__pUBKEY: '/manager/unlock/:pubkey',

  ORDER_TRANSACTION__ALL: '/order-transaction/all',
  ORDER_TRANSACTION__SINGLE: '/order-transaction/single',
  ORDER_TRANSACTION__USER_HISTORY: '/order-transaction/user-history',
  ORDER__OPEN_ORDERS: '/order/open-orders',
  ORDER__PAGINATE: '/order/paginate',
  ORDER__RANGE_FILTER: '/order/range-filter',
  ORDER__SINGLE: '/order/single',

  PRIZE: '/prize/',
  PRIZE__cAMPAIGN_TYPE__iD: '/prize/:campaign_type/:id',
  PRIZE__iD: '/prize/:id',
  PRIZE__BY: '/prize/by-key',

  SETTING__ADD_CUSTOM_COIN: '/setting/add-custom-coin',
  SETTING__ADMIN_LIMIT_WITHDRAWAL: '/setting/admin-limit-withdrawal',
  SETTING__ADMIN_LIMIT_WITHDRAWALS: '/setting/admin-limit-withdrawals',
  SETTING__COIN_SETTING: '/setting/coin-setting',
  SETTING__COIN_SETTING__CLOSE_COIN__cOIN: '/setting/coin-setting/close-coin/:coin',
  SETTING__COIN_SETTING__CLOSE_MARKET__cOIN__cURRENCY: '/setting/coin-setting/close-market/:coin/:currency',
  SETTING__COIN_SETTING__OPEN_COIN__cOIN: '/setting/coin-setting/open-coin/:coin',
  SETTING__COIN_SETTING__OPEN_MARKET__cOIN__cURRENCY: '/setting/coin-setting/open-market/:coin/:currency',
  SETTING__COIN_SETTINGS: '/setting/coin-settings',
  SETTING__COINS: '/setting/coins',
  SETTING__CRYPTO_SETTING: '/setting/crypto-setting',
  SETTING__CRYPTOEXCHANGECONFIG: '/setting/cryptoexchangeconfig',
  SETTING__HASH: '/setting/hash',
  SETTING__LIMIT_WITHDRAWAL: '/setting/limit-withdrawal',
  SETTING__LISTPUBKEYTOACTIVELISTCRYPTOEXCHANGE: '/setting/listpubkeytoactivelistcryptoexchange',
  SETTING__MARKETS: '/setting/markets',
  SETTING__PUBKEYACTIVELISTCRYPTOEXCHANGE: '/setting/pubkeyactivelistcryptoexchange',
  SETTING__PUBKEYTOACTIVELISTCRYPTOEXCHANGE: '/setting/pubkeytoactivelistcryptoexchange',
  SETTING__TOKEN: '/setting/token',
  SETTING__TOKEN_TOMO: '/setting/token-tomo',
  SETTING__TOMO_COINS: '/setting/tomo-coins',
  SETTING__TURN_OFF: '/setting/turn-off',
  SETTING__UPDATE_COIN: '/setting/update-coin',
  SETTING__UPDATE_COIN_SETTING: '/setting/update-coin-setting',
  SETTING__UPDATE_LIMIT_WITHDRAWAL: '/setting/update-limit-withdrawal',

  STATISTIC__EXT_TRANS: '/statistic/ext-trans',
  STATISTIC__INOUT_ORDER_TRANS: '/statistic/inout-order-trans',
  STATISTIC__INOUT_ORDER_TRANS_CHART: '/statistic/inout-order-trans-chart',
  STATISTIC__INOUT_TRANS: '/statistic/inout-trans',
  STATISTIC__INOUT_TRANS_CHART: '/statistic/inout-trans-chart',
  STATISTIC__INOUT_TRANS_EXTERNAL: '/statistic/inout-trans-external',
  STATISTIC__INOUT_TRANS_EXTERNAL_CHART: '/statistic/inout-trans-external-chart',
  STATISTIC__ORDER_TRANS: '/statistic/order-trans',
  STATISTIC__SYNC_ERC20: '/statistic/sync-erc20',
  STATISTIC__SYNC_ETH: '/statistic/sync-eth',
  STATISTIC__SYNC_TOMO: '/statistic/sync-tomo',
  STATISTIC__SYNC_TOMO_ERC20: '/statistic/sync-tomo-erc20',
  STATISTIC__TOTAL_TRANSACTION: '/statistic/total-transaction',
  STATISTIC__TRANS: '/statistic/trans',
  STATISTIC__WALLET_BALANCE: '/statistic/wallet-balance',
  STATISTIC__WALLET_BALANCE_CACHE: '/statistic/wallet-balance-cache',

  TOOLS__USER_BY_ADDRESS: '/tools/user-by-address',

  TRANSACTION__ACCEPT: '/transaction/accept',
  TRANSACTION__DELETE_TX_ERROR: '/transaction/delete-tx-error',
  TRANSACTION__HISTORY: '/transaction/history',
  TRANSACTION__HISTORY_API__ADDRESS__aDDRESS: '/transaction/history-api/address/:address',
  TRANSACTION__HISTORY_FILTER: '/transaction/history-filter',
  TRANSACTION__HISTORY__ADDRESS__aDDRESS: '/transaction/history/address/:address',
  TRANSACTION__LIMIT_24H: '/transaction/limit-24h',
  TRANSACTION__SEARCH_TX_ERROR: '/transaction/search-tx-error',
  TRANSACTION__SINGLE: '/transaction/single',
  TRANSACTION__TX_ERROR: '/transaction/tx-error',
  TRANSACTION__TX_ERROR_FILTER: '/transaction/tx-error-filter',
  TRANSACTION__USER_HISTORY: '/transaction/user-history',
  TRANSACTION__VERIFY: '/transaction/verify',
  TRANSACTION__WITHDRAWAL: '/transaction/withdrawal',

  USER__BALANCES: '/user/balances',
  USER__CHECKVERIFYPROFILE: '/user/checkverifyprofile',
  USER__EXPORT_DATA: '/user/export-data',
  USER__INFO: '/user/info',
  USER__INFO_BY_PUBKEY: '/user/info-by-pubkey',
  USER__LIST_ADDRESSES__pUBKEY: '/user/list-addresses/:pubkey',
  USER__LIST_INFO: '/user/list-info',
  USER__LIST_OVER_LIMIT: '/user/list-over-limit',
  USER__LOCK__pUBKEY: '/user/lock/:pubkey',
  USER__LOGIN_HISTORIES: '/user/login-histories',
  USER__LOGIN_HISTORY: '/user/login-history',
  USER__PAGINATE: '/user/paginate',
  USER__UNLOCK__pUBKEY: '/user/unlock/:pubkey',
  USER__UNVERIFYPROFILE: '/user/unverifyprofile',
  USER__VERIFYPROFILE: '/user/verifyprofile',
  USER__WARNING: '/user/warning',
  USER__WARNING__pUBKEY__cREATED_AT: '/user/warning/:pubkey/:created_at',
};

const SC_CONST = {
  ORDER_HISTORY: '/order/orders',
  ORDER_TRANS_HISTORY: '/order-transaction/all',
  WITHDRAW_HISTORY: '/transaction/history',

  LIST_USER: '/user/paginate',
  LOGIN_HISTORY: '/user/login-histories',

  SETTING_COIN: '/settings/coin',
  SETTING_FEE_TRANS: '/settings/transaction-fee',
  TRANS_FEE: '/settings/order-fee',

  TOOL_TRACE_ADDRESS: '/tool/trace-address',

  ADMIN_MANAGEMENT: '/admin/all-admins',
  ROLE_MANAGEMENT: '/authorization/roles',
  PERM_MANAGEMENT: '/authorization/permissions',
  PERM_ACTION_MANAGEMENT: '/authorization/controls',

  STATIS_ORDER_TRANS: '/statistic/inout-order-trans',
  STATIS_INOUT_TRANS: '/statistic/inout-trans',
  STATIS_INOUT_TRANS_EXTERNAL: '/statistic/inout-trans-external',
  STATIS_WALLET_BALANCE: '/statistic/wallet-balance',
};

const CONTROLS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

const LangDateVi = {
  lang: {
    locale: 'vi_VN',
    placeholder: 'Chọn ngày',
    rangePlaceholder: ['Ngày bắt đầu', 'Ngày kết thúc'],
    today: 'Hôm nay',
    now: 'Bây giờ',
    backToToday: 'Quay lại hôm nay',
    ok: 'Đồng ý',
    clear: 'Làm mới',
    month: 'Tháng',
    year: 'Năm',
    timeSelect: 'Chọn thời gian',
    dateSelect: 'Chọn ngày',
    monthSelect: 'Chọn tháng',
    yearSelect: 'Chọn năm',
    decadeSelect: 'Chọn thập kỷ',
    yearFormat: 'YYYY',
    dateFormat: 'M/D/YYYY',
    dayFormat: 'D',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
    previousMonth: 'Tháng trước (Trang trên)',
    nextMonth: 'Tháng sau (Trang dưới)',
    previousYear: 'Năm ngoái (Control + trái)',
    nextYear: 'Năm sau (Control + phải)',
    previousDecade: 'Thập kỷ vừa qua',
    nextDecade: 'Thập kỷ tới',
    previousCentury: 'Thế kỷ trước',
    nextCentury: 'Thế kỷ tới',
  },
  timePickerLocale: {
    placeholder: 'Chọn thời gian',
  },
  dateFormat: 'YYYY-MM-DD',
  dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
  weekFormat: 'YYYY-wo',
  monthFormat: 'YYYY-MM',
};

export default {
  // ============ RBAC ============
  // todo define all controls in screen here...
  LangDateVi,
  CONTROLS,
  MAP_CRYPTOS: {
    [SC_CONST.ORDER_HISTORY]: CONTROLS,
    [SC_CONST.ORDER_TRANS_HISTORY]: CONTROLS,
    [SC_CONST.WITHDRAW_HISTORY]: CONTROLS,
    [SC_CONST.LIST_USER]: CONTROLS,
    [SC_CONST.LOGIN_HISTORY]: CONTROLS,
    [SC_CONST.SETTING_COIN]: CONTROLS,
    [SC_CONST.SETTING_FEE_TRANS]: CONTROLS,
    [SC_CONST.TRANS_FEE]: CONTROLS,
    [SC_CONST.TOOL_TRACE_ADDRESS]: CONTROLS,
    [SC_CONST.ADMIN_MANAGEMENT]: CONTROLS,
    [SC_CONST.ROLE_MANAGEMENT]: CONTROLS,
    [SC_CONST.PERM_MANAGEMENT]: CONTROLS,
    [SC_CONST.PERM_ACTION_MANAGEMENT]: CONTROLS,
    [SC_CONST.STATIS_ORDER_TRANS]: CONTROLS,
    [SC_CONST.STATIS_INOUT_TRANS]: CONTROLS,
    [SC_CONST.STATIS_INOUT_TRANS_EXTERNAL]: CONTROLS,
    [SC_CONST.STATIS_WALLET_BALANCE]: CONTROLS,
  },

  // for RBAC
  ALL_NAMESPACES: {
    RolePermissionController: 'Quản lý phân quyền',
    RoleUserController: 'Quản lý phân quyền',
    RoleController: 'Quản lý phân quyền',
    AuthorControlController: 'Quản lý phân quyền',
    RolePermsControlController: 'Quản lý phân quyền',
    PermissionController: 'Quản lý phân quyền',

    CommissionController: 'Quản trị hệ thống giới thiệu',
    LuckyRotateController: 'Quản trị vòng quay may mắn',
    AdminController: 'Quản trị thành viên',
    SettingController: 'Thiết lập sàn giao dịch',
    ToolsController: 'Công cụ',
    UserController: 'Quản trị người dùng',
    StatisticController: 'Quản trị thống kê',
    TransactionController: 'Quản trị giao dịch',
    AdminNotificationController: 'Quản trị thông báo',
    PrizeController: 'Quản trị giải thưởng',
    OrderTransactionController: 'Quản trị giao dịch',
    OrderController: 'Quản trị giao dịch',
    FavoriteController: 'Quản trị hệ thống giới thiệu',
    CampaignController: 'Quản trị thông báo',
    AffiliateController: 'Quản trị hệ thống giới thiệu',
    ExchangeController: 'Thiết lập sàn giao dịch',
  },

  // ============ RBAC ============

  TYPE_ERROR: 'error',
  TYPE_WARNING: 'warning',
  TYPE_SUCCESS: 'success',
  TYPE_INFO: 'info',
  FORM_LAYOUT: {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
  },
  MODAL_CONFIG_PREFIX: '',
  MODAL_DETAIL: 'detail',
  MODAL_EDIT: 'edit',
  MODAL_DEL: 'del',
  MODAL_ADD: 'add',
  MODAL_DOWNLOAD: 'download',
  MODAL_API_GROUP: 'api_group',
  MODAL_CONFIG_DETAIL: 'config_detail',
  MODAL_CONFIG_EDIT: 'config_edit',
  MODAL_CONFIG_CLONE: 'config_clone',
  MODAL_CONFIG_DEL: 'config_del',
  MODAL_CONFIG_ADD: 'config_add',
  MODAL_CONFIG_DOWNLOAD: 'config_download',
  MODAL_API_GROUP_DETAIL: 'api_group_detail',
  MODAL_API_GROUP_EDIT: 'api_group_edit',
  MODAL_API_GROUP_DEL: 'api_group_del',
  MODAL_API_GROUP_ADD: 'api_group_add',
  MODAL_API_GROUP_DOWNLOAD: 'api_group_download',
  DEFAULT_HEADERS: {},
  ORDER_TRADE_TYPE_BUY: 0,
  ORDER_TRADE_TYPE_BUY_STR: 'Buy',
  ORDER_TRADE_TYPE_SELL: 1,
  ORDER_TRADE_TYPE_SELL_STR: 'Sell',

  ORDER_TYPE_LIMIT: 0,
  ORDER_TYPE_MARKET: 1,
  ORDER_TYPE_STOP_LIMIT: 2,
  ORDER_TYPE_STOP_MARKET: 3,
  ORDER_TYPE_LIMIT_STR: 'Limit',
  ORDER_TYPE_MARKET_STR: 'Market',
  ORDER_TYPE_STOP_LIMIT_STR: 'Stop Limit',
  ORDER_TYPE_STOP_MARKET_STR: 'Stop Market',

  ORDER_STATUS_STOPPING: 0,
  ORDER_STATUS_PENDING: 1,
  ORDER_STATUS_EXECUTED: 2,
  ORDER_STATUS_CANCELED: 3,
  ORDER_STATUS_EXECUTING: 4,
  ORDER_STATUS_REMOVED: 5,
  ORDER_STATUS_STOPPING_STR: 'Stopping',
  ORDER_STATUS_PENDING_STR: 'Pending',
  ORDER_STATUS_EXECUTED_STR: 'Executed',
  ORDER_STATUS_CANCELED_STR: 'Canceled',
  ORDER_STATUS_EXECUTING_STR: 'Executing',
  ORDER_STATUS_REMOVED_STR: 'Removed',

  TRANSACTION_STATUS_SUCCESS: 0,
  TRANSACTION_STATUS_PENDING: 1,
  TRANSACTION_STATUS_SUBMITTED: 2,
  TRANSACTION_STATUS_ERROR: 3,
  TRANSACTION_STATUS_CANCEL: 4,
  TRANSACTION_STATUS_REJECTED: 5,
  TRANSACTION_STATUS_SUCCESS_STR: 'Succeed',
  TRANSACTION_STATUS_PENDING_STR: 'Pending',
  TRANSACTION_STATUS_SUBMITTED_STR: 'Submitted',
  TRANSACTION_STATUS_ERROR_STR: 'Error',
  TRANSACTION_STATUS_CANCEL_STR: 'Cancel',
  TRANSACTION_STATUS_REJECTED_STR: 'Rejected',

  TRANSACTION_TYPE_DEPOSIT: 0,
  TRANSACTION_TYPE_WITHDRAW: 1,
  TRANSACTION_TYPE_DEPOSIT_STR: 'Trans Deposit',
  TRANSACTION_TYPE_WITHDRAW_STR: 'Trans Withdraw',

  TYPE_ALL: -1,

  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE_SIZE_OPEN_ORDER: 25,

  PREFIX_FRONT_URL: '/v1/cryptotrading',
  routes: {
    LIST_USERS: 'user/paginate',
    USER_WALLET: 'user/wallet',
    DEPOSIT: 'user/wallet/deposit',
    WITHDRAW: 'user/wallet/withdrawal',
    DEPOSIT_WITHDRAWAL: 'user/wallet/deposit-withdrawal',
    OPEN_ORDER: 'user/wallet/open-order',
    ORDER_HISTORY: 'user/wallet/order-history',
    BUY_WITH_CARD: 'buy-with-card',
    HOME: 'home',
    ROOT: 'root',
    LOGIN: 'login',
    VERIFY: 'verify/email',
    VERIFY_WITHDRAW: 'verify/withdrawal',
    USER_SECURITY: 'user/security',
  },
  style: {
    COMMON_GUTTER: 16,
  },

  DEFAULT_MARGIN: 10,
  DEFAULT_DURATION: 300,
  PRIMARY_COLOR: '#1DA57A',
  COLOR_BUY: '#2EBD85',
  COLOR_SELL: '#E0294A',

  ERC_20: 'erc20',
  ETH: 'eth',

  SYMBOL_ETH: 'ETH',
  SYMBOL_BTC: 'BTC',
  SYMBOL_ERC20: 'ERC20',
  SYMBOL_TOMO: 'TOMO',
  SYMBOL_TOMO_ERC20: 'TOMO_ERC20',

  EN: 'en',
  VI: 'vi',
  KO: 'korea',

  AUTH,
};
